import React, {useMemo} from 'react'
import {REGEX_XENDIT_PREFIX} from 'consts'
import {useTranslation} from 'i18n'
import {PaymentDetailsInstructionsProps} from './PaymentDetailsInstructionsProps'
import {PaymentCheckoutExpandDetails} from '../ExpandDetails'

export default function PaymentDetailInstructions({
  bank,
  accountNumber,
}: PaymentDetailsInstructionsProps) {
  const {translate} = useTranslation()

  const handleInstruction = useMemo(
    () => (
      <>
        <PaymentCheckoutExpandDetails
          label={translate('global:mBanking', {context: bank})}
          description={translate('payment:virtualmBankingDescription', {
            Account:
              bank === 'BSI'
                ? accountNumber.replace(REGEX_XENDIT_PREFIX, '')
                : accountNumber,
            context: bank,
          })}
          isDescFormat
        />
        <PaymentCheckoutExpandDetails
          label={translate('global:eBanking')}
          description={translate('payment:virtualiBankingDescription', {
            Account: accountNumber,
            context: bank,
          })}
        />
        <PaymentCheckoutExpandDetails
          label={translate('global:transferATM')}
          description={translate('payment:virtualAtmDescription', {
            Account: accountNumber,
            context: bank,
          })}
        />
      </>
    ),
    [accountNumber, bank, translate],
  )

  const handleBRIExtra = useMemo(
    () =>
      bank === 'BRI' && (
        <>
          <PaymentCheckoutExpandDetails
            label={translate('global:transferMiniATM')}
            description={translate('payment:virtualMiniAtmDescription_BRI')}
          />
        </>
      ),
    [bank, translate],
  )

  return (
    <>
      {handleInstruction}
      {handleBRIExtra}
    </>
  )
}
